<template>
  <div class="rew19_aro_wrap shop">
    <div class="rew19_contents_inner">
      <h2 class="rew19_second_title">나의 에이지락 미 철회</h2>
      <ul class="rew19_basketAdd_exp">
        <li>철회 하고자 하는 에이지락 미 리워드 프로그램 번호는 {{adr_no}} 입니다.</li>
        <li>자동이체로 철회진행 시 3일의 철회기간이 소요됩니다.</li>
        <li>접수하신 후 철회 대기로 진행되며, 추가할인금액 결제 확인 후 철회처리 됩니다. 추가할인금액이 결제된 후 철회가 완료됩니다.</li>
      </ul>
      <h3 class="rew19_third_title">세부 정보</h3>
      <ul class="rew19_underline_list">
        <li class="type1">
          <em>수령인</em>
          <span class="substance">{{$nvl(viewData.pd_detail.ship_name, "-")}}</span>
        </li>
        <li class="type1">
          <em>전화번호</em>
          <span class="substance">{{$nvl(viewData.pd_detail.ship_tel, "-")}}</span>
        </li>
        <li class="type1">
          <em>핸드폰 번호</em>
          <span class="substance">{{$nvl(viewData.pd_detail.hand_phone, "-")}}</span>
        </li> 
        <li class="type1">
          <em>결제정보</em>
          <span class="substance">자동이체 ({{$nvl(viewData.pd_detail.bank_account, "-")}})
            <br/>
            생년월일 : 
            <input v-model.trim="birth" ref="birth"
              @keypress="numberKeyPress($event)"
              @keyup="keyUpToNumber($event)"                   
              maxlength="6"                  
              title="생년월일 입력" type="tel" class="autoFocus rew19_inputTxt_t1" placeholder="주민등록번호 앞 6자리">  
            <br/>(주민등록번호 앞 6자리)            
          </span>          
        </li>       
        <li class="type1"
          v-if="viewData.pd_detail.ship_address1 && viewData.pd_detail.ship_address2">
          <em>배송주소</em>
          <span class="substance">{{$nvl(viewData.pd_detail.ship_address1, "")}} {{$nvl(viewData.pd_detail.ship_address2, "")}}</span>
        </li>
        <li v-else class="type1">
          <em>배송주소</em>
          <span class="substance">-</span>
        </li>
        <li class="type1">
          <em>배송일</em>
          <span class="substance">매월 {{$nvl(viewData.pd_detail.delivery_day, "-")}} 일 
            (시작 월: {{$nvl(viewData.pd_detail.start_ym, "-")}})</span>
        </li>
        <li class="type1">
          <em>신청일</em>
          <span class="substance">{{$nvl(viewData.pd_detail.start_date, "-")}}</span>
        </li>
        <li class="type1">
          <em>결제일</em>
          <span class="substance">매월 {{$nvl(viewData.pd_detail.payment_day, "-")}} 일</span>
        </li>
      </ul>

      <div class="rew19_responsive_btns gepTaye1">
        <a @click="onClickCancel" class="rew19-btn-border">취소</a>
        <a @click="onClickWithdraw" class="rew19-btn-normal">철회하기</a>
      </div>
    </div>
    <!--rew19_contents_inner-->
  </div>
</template>
<script>
import AroBase from '@/components/base/AroBase';
import * as ErrMsg from "@/utils/error_msg";

export default {
  name: "WithdrawAccount",
  extends: AroBase,
  components: { }, 
  props:{
    adr_no: {
      type: String,
      required: true
    },    
  },
  data() { 
    return {     
      //View Data 

      viewData : {
        mileage : {},
        pd_detail: {}
      },
      
      birth : null
    }
  },
  created() {
  },
  mounted() {
    let _this = this;
  },
  methods: {    
    /**
     * JQuery UI
     */
    initUI(){
      
    },
    
    /**
     * Local function
     */
    initData(paramData){
      let _this = this;

      _this.viewData = {
        ...paramData
      };
    },

    //취소
    onClickCancel(){
      this.$emit('cancel');
    },

    //철회 하기
    onClickWithdraw(){
      let _this = this;

      //생년월일
      let chVal = _this.birth;
      if(!chVal || chVal.trim() == ""){
        _this.$dialogs.alert("생년월일 입력해 주십시오.")
        .then(res => {
          _this.$refs.birth.focus();
        });   
        return;
      }

      let regExBirth = /^\d{2}(0[0-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/;
      if(!regExBirth.test(chVal)){
        _this.$dialogs.alert("생년월일 6자리 숫자로 입력해 주십시오.")
        .then(res => {
          _this.$refs.birth.focus();
        });   
        return;
      }

      _this.$emit('doWithdraw', _this.AroConst.VALUE_payment_type_account_transfer, {birth : _this.birth});
    },

    numberKeyPress(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    keyUpToNumber(evt){
      evt = (evt) ? evt : window.event;
      evt.target.value = evt.target.value.replace(/[^0-9]/g, "");
    },
  }
}
</script>
<style>
a.rew19-btn-border, a.rew19-btn-normal{
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/my/ageloc/withdrawAccount.vue